import { useEffect } from 'react';
import { EventsType } from 'models/IdleTimer';

export type EventListenerConfig = {
  enabled?: boolean;
  capture?: boolean;
};

type UseAddEventListenerOptions = {
  event: EventsType;
  handler: (e: any) => void;
} & EventListenerConfig;

export default function useAddEventListener({
  event,
  handler,
  capture = false,
  enabled = true,
}: UseAddEventListenerOptions) {
  useEffect(() => {
    if (!enabled) return;

    document.addEventListener(event, handler, capture);

    return () => {
      document.removeEventListener(event, handler, capture);
    };
  }, [event, handler, capture, enabled]);
}
